import { Reveal } from "./Reveal";

const included = [
  { title: "Private 1:1 sessions on Zoom", desc: "Personal coaching sessions with Shellie, each month across the full six months." },
  { title: "Support between sessions", desc: "Voice-note access for the moments that can't wait for the next call." },
  { title: "Your family phrase map", desc: "A personalized language map for your hardest moments — the store, bath time, bedtime." },
];

const testimonials = [
  {
    quote: "I prepped my 5-year-old before the store just like you taught me… not one single meltdown.",
    author: "Allison, mom of 3 boys",
  },
  {
    quote: "I feel like I'm in control. I no longer tense at the thought of my 3-year-old's reaction when I say something.",
    author: "Victoria, mom of 2 boys",
  },
];

export const Included = () => (
  <section data-testid="included-section" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
        <div className="md:col-span-5">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8C4A32] mb-4">What's included</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#241E1A] font-medium">
              Six months. Private. Entirely around your family.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7 space-y-4">
          {included.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div data-testid={`included-item-${i + 1}`} className="rounded-2xl bg-[#F4EFE6] border border-[#E6DEC3] p-6 sm:p-7 flex gap-5 items-start transition-transform duration-500 hover:-translate-y-1">
                <span className="mt-1 w-2 h-2 rounded-full bg-[#8C4A32] shrink-0" />
                <div>
                  <h3 className="font-serif-display text-xl sm:text-2xl text-[#241E1A] font-semibold">{item.title}</h3>
                  <p className="mt-1.5 text-base leading-relaxed text-[#5C524A]">{item.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
        <div className="md:col-span-4">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8C4A32] mb-4">What moms are saying</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl leading-[1.15] text-[#241E1A] font-medium">
              Real mothers. Real mornings after.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.12} className="h-full">
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="h-full rounded-2xl bg-white border border-[#EFE6D8] p-7 sm:p-8 flex flex-col shadow-[0_16px_40px_-24px_rgba(36,30,26,0.25)]"
              >
                <span className="font-serif-display text-5xl leading-none text-[#C69C6D]">&ldquo;</span>
                <blockquote className="mt-2 font-serif-display italic text-xl sm:text-2xl leading-snug text-[#241E1A]">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-auto pt-5 text-xs uppercase tracking-[0.2em] font-semibold text-[#8C4A32]">
                  — {t.author}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
